import { ref } from 'vue'
import { useSessionStore } from '@/stores/SessionStore'
import { useUserStore } from '@/stores/UserStore'
import { useCachedFetch } from '@/composables/useFetch'
import useConfigurationGlobals from '@/composables/useConfigurationGlobals'

const { $BASEURL } = useConfigurationGlobals();

export const useApiData = (group) => {
  const request = async (endPoint, options, overrideCache = false) => {
    const sessionStore = useSessionStore();
    const userStore = useUserStore()
  
    const params = {
      ...options,
      units_wind: userStore.unitsWind,
      units_temp: userStore.unitsTemp,
      units_distance: userStore.unitsDistance,
      units_precip: userStore.unitsPrecip,
      units_height: userStore.unitsHeight,
      wf_token: sessionStore.token
    }
  
    const queryString = new URLSearchParams(params).toString()
    const url = `${$BASEURL}/${group}/${endPoint}?${queryString}`
  
    // Always resolve to a consistent { data, error } shape (both refs) so
    // destructuring callers can safely read error.value / data.value on any path.
    let data = ref(null)
    let error = ref(null)

    try {
      ({ error, data } = await useCachedFetch(url, {}, true, overrideCache))

      if (error.value) {
        throw error.value
      }

      if (data.value.status?.status_code !== 0 && data.value.status_code !== 0) {
        throw data.value.status || data.value.status_code
      }
    } catch (err) {
      console.warn(err)

      // Surface the failure through error.value instead of changing the return
      // shape. error.value is already set on a fetch error; set it for a thrown
      // status code or a rejected cached response.
      if (!error.value) {
        error.value = err
      }
    }

    return { data, error }
  }

  return { request }
}
